export default __webpack_public_path__ + "static/media/X.eb741b65.svg";